import React from "react";

const WalkIcon = ({
  size = 16,
  color = "#222222",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size * (10 / 16)}
      height={size}
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M2.95285 10.8636L2.9841 10.926L4.14025 11.9562L3.70279 13.0175C3.5778 13.3609 3.35907 13.6731 3.10909 13.9228L1.26551 15.7646C1.14052 15.8895 0.953038 15.9832 0.734308 15.9832C0.546825 15.9832 0.359342 15.8895 0.234354 15.7646C-0.0781178 15.4525 -0.0781178 14.9842 0.234354 14.7033L2.04669 12.8615C2.17168 12.7678 2.26542 12.6117 2.32791 12.4556L2.95285 10.8636ZM6.48378 2.99684C5.67135 2.99684 4.98392 2.34128 4.98392 1.49842C4.98392 0.686777 5.67135 0 6.48378 0C7.32745 0 7.98364 0.686777 7.98364 1.49842C7.98364 2.34128 7.32745 2.99684 6.48378 2.99684ZM9.76473 8.45984C10.4834 9.17783 9.38976 10.208 8.70233 9.55244L7.79616 8.64714C7.60868 8.45984 7.45244 8.2101 7.3587 7.96037C6.92124 6.61803 6.92124 6.52438 6.67126 6.21221L5.85884 9.49L7.54618 11.0509C7.9524 11.4255 8.23362 11.8937 8.35861 12.4244L8.9523 15.0779C9.04605 15.4837 8.79607 15.8895 8.38986 15.9832C7.9524 16.0768 7.57743 15.7646 7.51494 15.4213L6.88999 12.7678C6.8275 12.5181 6.70251 12.2995 6.51503 12.1435L4.0465 9.86461C3.60904 9.36514 3.45281 8.74079 3.60904 8.14767L4.20274 5.68152C3.85902 5.80638 3.5153 5.93125 2.82787 6.21221C2.51539 6.33707 2.26542 6.58681 2.10918 6.86777L1.67172 7.8355C1.26551 8.70958 -0.109365 8.08523 0.328095 7.17994L0.765555 6.21221C1.07803 5.58786 1.60923 5.08839 2.26542 4.80744C3.60904 4.27675 4.17149 3.99579 5.26514 3.99579C6.67126 3.99579 7.92115 4.90109 8.38986 6.24342L8.79607 7.46089C8.79607 7.49211 8.82732 7.55454 8.85856 7.55454L9.76473 8.45984Z"
        fill={color}
      />
    </svg>
  );
};

export default WalkIcon;